import moment from 'moment';
import {IDailyConsumptionDto, IUnitDto} from '../../../api/api';
import {getOneYearPrior} from '../../../utilities/helpers/date-helpers';
import {SortingDays} from './types';

export interface IConsumptionDateInputs {
  date: Date;
  organizationId: number | undefined;
}

export const setMonthlyConsumption = (dataPoints: IDailyConsumptionDto[]) => {
  let monthlyConsumption = 0;
  if (dataPoints) {
    dataPoints
      .filter((d) => d.date?.getMonth() === new Date().getMonth())
      .map((d) => (monthlyConsumption += d.consumptionValue!));
  }
  return monthlyConsumption;
};

export const getOneYearPriorSortingDays = (sortingDays: SortingDays) => {
  let newSortingDays = {} as SortingDays;
  newSortingDays.fromDate = getOneYearPrior(sortingDays.fromDate);
  newSortingDays.toDate = getOneYearPrior(sortingDays.toDate);
  return newSortingDays;
};

export const countUniqueConsumptionTimeStamps = (consumption: IDailyConsumptionDto[]) => {
  return consumption.filter(
    (consumption, index, self) =>
      index ===
      self.findIndex((t) => moment(t.date).valueOf() === moment(consumption.date).valueOf() && t.connectionId !== null),
  ).length;
};

export const getConnectionIdsInPeriod = (units: IUnitDto[], sortingDays: SortingDays) => {
  return units.filter((unit) => isUnitContractInPeriod(unit, sortingDays)).map((unit) => unit.connectionid!);
};

export const isUnitContractInPeriod = (unit: IUnitDto, sortingDays: SortingDays): boolean => {
  return unit.contractStartDate <= sortingDays.toDate && unit.contractEndDate >= sortingDays.fromDate;
};
